var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4284 0H59.9999V8.57143H51.4284V0ZM51.4284 12.8571H59.9999V21.4286H51.4284V12.8571ZM38.5713 0H47.1427V8.57143H38.5713V0ZM38.5713 12.8571H47.1427V21.4286H38.5713V12.8571Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7143 29.9994V42.8566H4.28571V8.57087H30V4.28516H4.28571C3.14907 4.28516 2.05898 4.73669 1.25526 5.54041C0.451529 6.34414 0 7.43423 0 8.57087V42.8566C0 43.9932 0.451529 45.0833 1.25526 45.887C2.05898 46.6908 3.14907 47.1423 4.28571 47.1423H21.4286V55.7137H12.8571V59.9994H47.1429V55.7137H38.5714V47.1423H55.7143C56.8509 47.1423 57.941 46.6908 58.7447 45.887C59.5485 45.0833 60 43.9932 60 42.8566V29.9994H55.7143ZM34.2857 55.7137H25.7143V47.1423H34.2857V55.7137Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService5);
export default __webpack_public_path__ + "static/media/service5.957572dda9df28de4785aed9ed13f366.svg";
export { ForwardRef as ReactComponent };